var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.62315C0.160114 9.41739 0.318433 9.20963 0.480292 9.00533C0.630243 8.81683 0.784797 8.6317 0.933661 8.44873C0.949591 8.44723 0.958618 8.44638 0.967644 8.44553C0.976671 8.44469 0.98676 8.44374 0.992045 8.44867C2.77459 9.94535 3.68914 10.8019 5.49273 12.3172L16.4576 0C16.5057 0.0394819 16.5651 0.0893231 16.6254 0.138528L17.5977 0.9306L17.6078 1.03831C17.5478 1.10154 17.4836 1.15866 17.4291 1.22844C15.6858 3.36241 7.42084 12.3723 5.67876 14.5073C3.56908 12.7351 2.32615 11.603 0.216085 9.83049C0.149781 9.77479 0.0757403 9.72796 0.00506224 9.67701L0 9.62315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.8abd813d4a00f4dccb806e28b54baff9.svg";
export { ForwardRef as ReactComponent };